export const STORAGE_KEYS = {
  PHONE_NUMBER: "identityVerificationPhoneNumber",
  VERIFICATION_ID: "identityVerificationId",
  USER_TERMS_AGREEMENT_LIST: "userTermsAgreementList",
} as const;